import { useStore } from '../store';
import { getSubscriptionStatus } from '../utils/subscription';
import { Crown, Clock, AlertTriangle, XCircle } from 'lucide-react';

export default function SubscriptionBadge() {
  const { subscription, setShowSubscriptionModal } = useStore();
  const status = getSubscriptionStatus(subscription);

  const colorClasses = {
    green: 'bg-green-100 text-green-800 hover:bg-green-200',
    blue: 'bg-blue-100 text-blue-800 hover:bg-blue-200',
    yellow: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200',
    red: 'bg-red-100 text-red-800 hover:bg-red-200',
    gray: 'bg-gray-100 text-gray-800 hover:bg-gray-200',
  };

  const Icon = {
    green: Crown,
    blue: Clock,
    yellow: AlertTriangle,
    red: XCircle,
    gray: XCircle,
  }[status.color];

  return (
    <button
      onClick={() => setShowSubscriptionModal(true)}
      className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium transition-colors ${colorClasses[status.color]}`}
      title="Manage subscription"
    >
      <Icon size={14} />
      <span>{status.label}</span>
    </button>
  );
}
